export default __webpack_public_path__ + "static/media/news.3d0b10d4.png";